import React, { useEffect } from 'react';
import useSWR from 'swr';
import { AssetTabMaintenanceCostsDataGrid } from '../../../components/datagrid/AssetTabMaintenanceCostsDataGrid';
import { CONFIG_KEYS, useConfigByKey } from '../../../contexts/configContext';
import { PageContentWrapper } from '../../../layouts/contentWrapper/PageContentWrapper';
import { MaintenanceCost, MaintenanceCostType } from '../../../types/maintenanceCost.types';
import { API_URL, fetcher } from '../../../utils/apiUrl';
import { assetEditSwrConfig, ITab, swrConfig } from '../../Assets/AssetsEdit';

interface Props extends ITab {
  taskId: number;
  assetId: number;
  isReadonly: boolean;
  onCostCountChange?: () => void;
}

/**
 * Záložka s evidencí nákladů na údržbu stroje navázaných na konkrétní požadavek (Task).
 * Zobrazuje se jen při aktivním modulu a s oprávněním na čtení strojů - stejná pravidla
 * jako na záložce assetu (#737, #757 - přidání na task).
 */
export function TaskMaintenanceCostsTab({
  active,
  taskId,
  assetId,
  isReadonly,
  onCostCountChange,
}: Props) {
  // měna je společná pro celou aplikaci, do záznamu se neukládá
  const currencyConfig = useConfigByKey(CONFIG_KEYS.MAINTENANCE_COST_CURRENCY);

  const {
    data: costs,
    error: errorCosts,
    mutate: mutateCosts,
    isValidating: costsIsValidating,
  } = useSWR<MaintenanceCost[]>(
    taskId ? `${API_URL.MAINTENANCE_COST_LIST_BY_TASK}?taskId=${taskId}` : null,
    fetcher,
    assetEditSwrConfig,
  );

  // číselník druhů nákladů - swrConfig (ne assetEditSwrConfig), ať se načte hned při mountu
  const { data: costTypes, error: errorCostTypes } = useSWR<MaintenanceCostType[]>(
    `${API_URL.MAINTENANCE_COST_TYPE_LIST}`,
    fetcher,
    swrConfig,
  );

  useEffect(() => {
    if (active) mutateCosts();
  }, [active]);

  const handleDataChanged = () => {
    mutateCosts();
    if (onCostCountChange) onCostCountChange();
  };

  return (
    <PageContentWrapper
      noContentBlock
      noDxCard
      error={errorCosts || errorCostTypes}
      loading={costsIsValidating}
    >
      <AssetTabMaintenanceCostsDataGrid
        assetId={assetId}
        data={costs}
        costTypes={costTypes}
        currency={currencyConfig?.value}
        isReadOnly={isReadonly}
        mutateData={handleDataChanged}
        defaultTaskId={taskId}
        hideTaskColumn
      />
    </PageContentWrapper>
  );
}
